import React from 'react';
export function Footer() {
  return <footer className="border-t border-brand-gold/20 px-4 py-6" data-id="element-94">
      <div className="max-w-6xl mx-auto text-center" data-id="element-95">
        <h3 className="font-serif text-xl sm:text-2xl text-brand-gold font-bold mb-1" data-id="element-96">
          REALMANIFESTACIÓN
        </h3>
        <p className="text-xs text-brand-gray mb-3" data-id="element-97">Manifestación Consciente</p>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-5 text-xs text-brand-gray mb-3" data-id="element-98">
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-99">
            Términos
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-100">
            Privacidad
          </a>
          <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-101">
            Contacto
          </a>
        </div>

        <p className="text-[10px] text-brand-gray" data-id="element-102">
          © 2026 Realmanifestación. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}